import type { TextCaptionProps } from '@carboncopyco/ui';
import { TextCaption } from '@carboncopyco/ui';

export interface DescriptionLinkProps {
  label: TextCaptionProps['label'];
  linkLabel: TextCaptionProps['label'];
  linkUrl?: HTMLAnchorElement['href'];
  onLearnMoreClick?: (url: string) => void;
}

export const DescriptionLink = ({
  label,
  linkLabel,
  linkUrl = 'https://www.demostack.com',
  onLearnMoreClick,
}: DescriptionLinkProps) => {
  return (
    <span>
      <TextCaption
        label={label}
        color="text-ds-natural-600"
      />
      <a
        className="pl-1"
        href={linkUrl}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => {
          e.stopPropagation();
          if (onLearnMoreClick) {
            e.preventDefault();
            onLearnMoreClick(linkUrl);
          }
        }}
      >
        <TextCaption
          label={linkLabel}
          color="text-ds-natural-600"
          underline
        />
      </a>
    </span>
  );
};
